/*
 * What this session is allowed to do, as the server said at sign-in (or as it
 * said since — see session.js).
 *
 *   'active'         a full plan
 *   'trial'          a free trial that is still running
 *   'trial_expired'  a free trial that ran out
 *   'expired'        a full plan that ran out
 *
 * The last two are "locked": the person stays signed in, but the app shows
 * the plans page and nothing else until access is restored. They can still
 * sign out. Sending them to the sign-in form instead left them with nothing
 * to do.
 *
 * This is for the interface only — which buttons to show, which banner,
 * where to send someone. The server enforces every limit on its own
 * (requireActivePlan.js, noTrial.js).
 */

function ss(key) {
  try { return sessionStorage.getItem(key) || '' } catch (err) { return '' }
}

export function accessState() {
  return ss('AccessState') || 'active'
}

export function isTrial() {
  const state = accessState()
  return state === 'trial' || state === 'trial_expired'
}

/* Signed in, but access has ended: plans only. */
export function isLocked() {
  const state = accessState()
  return state === 'trial_expired' || state === 'expired'
}

/* Kept for the screens that ask specifically about an ended trial. */
export function isTrialExpired() {
  return accessState() === 'trial_expired'
}

/* Milliseconds left in a running trial, or 0. */
export function trialMsLeft() {
  const raw = ss('TrialEndsAt')
  if (!raw) return 0
  const left = new Date(raw).getTime() - Date.now()
  return Number.isFinite(left) && left > 0 ? left : 0
}

/* "23h 14m", "42m", "under a minute" */
export function formatLeft(ms) {
  const mins = Math.floor(ms / 60000)
  if (mins < 1) return 'under a minute'
  const h = Math.floor(mins / 60)
  const m = mins % 60
  return h > 0 ? h + 'h ' + m + 'm' : m + 'm'
}

/* "29 September 2026", from 'YYYY-MM-DD'. */
export function formatDay(ymd) {
  if (!ymd) return ''
  const d = new Date(String(ymd) + 'T00:00:00')
  return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
}

/* The only page a locked session may open. */
export const LOCKED_PAGES = ['plans']

/* Pages an ended trial may still open — used by ProtectedRoute. */
export const EXPIRED_TRIAL_PAGES = ['plans', 'profile']
